import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';

const devUrl = environment.backendurl

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }


  signup(data) {
    var url = devUrl + "/user/register"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Signup User', url)));
  }

  login(data) {
    var url = devUrl + "/user/login"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError((err: HttpErrorResponse) => throwError(err)));
  }

  /** Second step for admin / privileged logins: verifies the emailed one-time code */
  verifyLoginOtp(data) {
    var url = devUrl + "/user/login/verifyotp"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError((err: HttpErrorResponse) => throwError(err)));
  }

  forgetpassword(data) {
    var url = devUrl + "/user/forgotpassword"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Forget Password', url)));
  }

  resetpassword(data) {
    var url = devUrl + "/user/changepassword"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Reset Password', url)));
  }


  isloggedin(userid){
    var url = devUrl + '/user/isloggedin?usernumber=' + userid
    return this.http.get(url).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('is Logged in', url)))
  }

  logOut(data){
    var url = devUrl + "/user/logout"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('User Logout', url)));
  }

  ontheflytoken (data) {
    var url = devUrl + "/ontheflytoken"
    return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Onthefly token', url)));
  }

 fetchuserdetails(userid){
  var url = devUrl + '/user/fetchdetails?usernumber=' + userid
  return this.http.get(url).pipe(
    map(response => { return response; })
    , catchError(GlobalService.handleError('is Logged in', url)))
}

  checkpasswordlinkvalidity(data){
    var url = devUrl + '/user/isresetlinkvalid';
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Reset Password Link Validity', url)));
  }


updateuserDetails(data){
  var url = devUrl + "/user/updatedetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('updateuserDetails', url)));
}

changeuserPassword(data){
  var url = devUrl + "/user/changepasswordafterlogin"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('changeuserPassword', url)));
}

resendVerificationEmail(data){
  var url = devUrl + "/user/resendverifyemail"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('resendVerificationEmail', url)));
}

  federatedLinkedInLogin(data) {
    var url = devUrl + "/federatedlinkedinlogin"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Federated LinkedIn Login: ', url)));
  }

  
  getTagUsers(data, fetchAll: boolean = false){
    let url = devUrl + `/typeahead/tagUsers?user=${encodeURIComponent(data)}`;
    fetchAll && (url += '&all=true');
      return this.http.get(url).pipe(
        map(response=> {return response}),
        catchError(GlobalService.handleError('Failed gettin user',url))
      )
  }

  sendMentionedEmail(data){
    const url = devUrl + "/user/sendMentionEmail"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Federated LinkedIn Login: ', url)));

  }

  getGeoIpLocationOfUser(updateLocation = false) {
    const url = devUrl + `/user/ip-location${updateLocation ? '?updateLocation=true' : ''}`;
    return this.http.get(url).pipe(
      map(response => { return response; }),
      catchError(GlobalService.handleError('Failed to get user location', url))
    )
  }

  /**
   * Used to track session of user
   * @param data 
   * @returns 
   */
  userSessionTracker(data = {}) {
    const url = devUrl + `/user/session-tracker`;
    return this.http.post<any>(url, data, { observe: 'response' }).pipe(
      map(response => ({ ...response, statusCode: response.status })),
      catchError((err: HttpErrorResponse) => throwError(err))
    )
  }

  /**
   * Used to verify password link is valid or not
   */
  verifySetPasswordLink(data) {
    const url = devUrl + `/user/verifysetpassword`;
    const params = new HttpParams().set('token', data);
    return this.http.get(url, { params: params, observe: 'response' }).pipe(
      map(response => ({ ...response.body, statusCode: response.status }),
        catchError((err) => throwError(err)))
    );
  }

  /**
   * Used to set password of users
   * @param data 
   * @returns 
   */
  setNewPassword(data) {
    const url = devUrl + `/user/set-password`;
    return this.http.patch(url, data, { observe: 'response' }).pipe(
      map(response => ({ ...response.body, statusCode: response.status })),
      catchError(err => throwError(err))
    );
  }
  
  newSignup(data) {
    var url = devUrl + "/user/signup"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Signup User', url)));
  }

  /**
   * Service to use user self signup
   * @param data 
   * @returns 
   */
  selfSignup(data: any) {
    const url = devUrl + "/user/selfsignup"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Self Signup User', url)));
  }


  /**
   * Get list of company on text search
   * @param searchText 
   * @returns 
   */
  getCompanyTypeAhead(searchText: string) {
    let url = devUrl + `/typeahead/company`;
    if (searchText.trim()) {
      url = url + '?' + 'company=' + searchText;
    }
    return this.http.get(url).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Self Signup User', url)));
  };

}

